module.exports = __webpack_public_path__ + "c85b80b12b0427723e972ba4b21ca264.png";